module.exports = __webpack_public_path__ + "9779d9a1/img/chevron-down-icon.5542f65c.svg";